// extracted by css-extract-rspack-plugin
export default {"Flash":"BlameBanners-module__Flash__NTdL7IJ","Box":"BlameBanners-module__Box__r70I99L"};